import { render, staticRenderFns } from "./AddDeadCPCA.vue?vue&type=template&id=7787dcdb&scoped=true"
import script from "./AddDeadCPCA.vue?vue&type=script&lang=js"
export * from "./AddDeadCPCA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7787dcdb",
  null
  
)

export default component.exports